import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageChanger from "../../Helpers/Components/Pagination"
import Handler from "../../Helpers/Components/Handler"
import moment from "moment";
import TablePlaceHolder from "../../Helpers/Components/TablePlaceHolder"
import DatePicker from "react-multi-date-picker";
import Select from 'react-select'

const List = () => {
    const { pageNo } = useParams()
    const navigate = useNavigate()
    const [next, setNext] = useState(false)
    const [loading, setLoading] = useState(false)
    const [custDetails, setCustDetails] = useState([])
    const [filter, setFilter] = useState({ count: 10, sortBy: "user_id", sort: true, search: "", createdBy: "All", custType: "All", type: "All", remarks: "All", custStatus: "All", })
    const [checkDate, setCheckDate] = useState()
    const calendarRef = useRef();
    const [search, setSearch] = useState("");
    const [appliedSearch, setAppliedSearch] = useState("");
    const setPageNo = (value) => navigate(`/old-cust/${value}`)
    const handleKeyDown = (event) => { if (event.key === "Enter") { event.preventDefault(); handleSearch(); } };
    const handleOpen = () => { if (calendarRef.current) { calendarRef.current.openCalendar(); } };
    const sort = (sortBy, sort) => {
        setPageNo(1)
        setFilter((prev) => ({ ...prev, sortBy: sortBy, sort: sort }))
    }
    const handleChange = (e) => {
        setPageNo(1)
        setFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }
    const getCustomerDetails = async () => {
        setLoading(true)
        const response = await Handler({
            method: "post", url: `/customer/details/msd/list/${pageNo}?count=${filter?.count || 10}`,
            data: {
                ...(appliedSearch ? { search: appliedSearch } : {}),
                ...(checkDate?.length ? { from: moment(new Date(checkDate[0]))?.format("DD-MM-YYYY"), to: checkDate?.length >= 2 ? moment(new Date(checkDate[1]))?.format("DD-MM-YYYY") : moment(new Date(checkDate[0]))?.format("DD-MM-YYYY") } : {}),
                sort: filter?.sort,
                sortBy: filter?.sortBy
            }
        })
        if (response?.success) {
            setCustDetails(response?.data?.current)
            setNext(response?.data?.next)
        } else {
            setCustDetails([])
            setNext(false)
        }
        setLoading(false)
    }
    const handleSearch = () => {
        setPageNo(1);
        setAppliedSearch(search);
    };
    useEffect(() => {
        getCustomerDetails()
    }, [pageNo, filter, checkDate, appliedSearch])
    return (
        <React.Fragment>
            <h5 className="text-center text-theme fs-4">Old Customer List</h5>
            <div className="layout-card mt-4">
                <div className="row justify-content-between align-items-center">
                    <div className="col-lg-4">
                        <div className="d-flex align-items-center gap-2">
                            <div className="input-group">
                                <input type="text" className="form-control search-input" onKeyDown={handleKeyDown} autoComplete="off" placeholder="Search..." value={search} onChange={(e) => { if (e.target.value) setSearch(e.target.value); else { setSearch(""); setAppliedSearch(""); setPageNo(1); } }} name="search" />
                                <span className="input-group-text cancel-icon">{search && (<i className="fa-solid fa-circle-xmark cursor-pointer text-theme" onClick={() => { setSearch(""); setAppliedSearch(""); setPageNo(1); }} />)}</span>
                            </div>
                            <button className="btn btn-sm btn-theme" onClick={handleSearch}>Search</button>
                        </div>
                    </div>
                </div>
                <div className='overflow list-table mt-3'>
                    <table className="table-bg table" borderless="true">
                        <thead>
                            <tr className="border-bottom" >
                                <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "user_id" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("user_id", false)} >▲</i><i className={filter?.sortBy === "user_id" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("user_id", true)} >▼</i></div> Cust Id</div></th>
                                <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "customer_name" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("customer_name", false)} >▲</i><i className={filter?.sortBy === "customer_name" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("customer_name", true)} >▼</i></div> Name </div></th>
                                <th>Primary No</th>
                                <th> Alt No </th>
                                <th> Alt No 1 </th>
                                <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "created_at" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("created_at", false)} >▲</i><i className={filter?.sortBy === "created_at" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("created_at", true)} >▼</i></div> <button className='created-at' onClick={() => { handleOpen() }}>Created At</button> </div></th>
                            </tr>
                        </thead>
                        <tbody>
                            {!loading ?
                                (custDetails && custDetails?.length !== 0 ? custDetails?.map((value, key) => {
                                    return (
                                        <tr key={key} className={`table-content-row ${!value?.status ? "text-red" : ""}`}>
                                            <td>{value?.user_id || "-"}</td>
                                            <td className="text-capitalize">{(value?.customer_name || "-")}</td>
                                            <td>{value?.mobile_no1 || ""}</td>
                                            <td>{value?.mobile_no2 || ""}</td>
                                            <td>{value?.mobile_no3 || ""}</td>
                                            <td>{value?.created_at ? moment(value?.created_at).format('DD/MM/YYYY') : ""}</td>
                                        </tr>
                                    )
                                }) :
                                    <tr className='text-center' ><td colSpan={6}>No Data Found</td></tr>)
                                : <TablePlaceHolder count={6} />
                            }
                        </tbody>
                    </table>
                </div>
                <div className="d-flex align-items-center justify-content-end mt-3">
                    <span className="me-2 fw-medium"> Page Count:  </span>
                    <Select
                        className="inside-select"
                        isDisabled={loading}
                        onChange={(selectedoption) => {
                            setFilter((prev) => ({ ...prev, count: Number(selectedoption?.value) }))
                            setPageNo(1)
                        }}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        value={filter?.count ? { label: filter?.count, value: filter?.count } : { label: 10, value: 10 }}
                        options={[
                            { label: 10, value: 10 },
                            { label: 20, value: 20 },
                            { label: 30, value: 30 },
                            { label: 40, value: 40 },
                            { label: 50, value: 50 },
                        ]}
                        placeholder="PageNo"
                    />
                </div>
                <PageChanger previousValue={Number(pageNo) > 1} nextValue={next} current={Number(pageNo)} onPageChange={setPageNo} pageValue='old-cust' />
            </div>
            <DatePicker
                ref={calendarRef}
                range
                className='rmdp-mobile'
                inputClass='d-none'
                onChange={(e) => { setPageNo(1); if (!isNaN(new Date(e[0]))) { setCheckDate(e); } }}
                value={checkDate}
                mobileButtons={[
                    {
                        label: "RESET",
                        type: "button",
                        className: "rmdp-button rmdp-action-button",
                        onClick: () => setCheckDate({}),
                    },
                ]}
            />

        </React.Fragment>
    )
}

export default List;